import { RecordForm } from "../RecordForm/index.js";
import "react";
import { Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Records/shared/CreateRecordModal/index.tsx
function CreateRecordModal({ closeHandler, onComplete }) {
	return /* @__PURE__ */ jsx(Modal, {
		width: "xl",
		closeHandler,
		showClose: false,
		children: /* @__PURE__ */ jsx(RecordForm, {
			onCancel: closeHandler,
			onComplete: (recordId) => {
				onComplete?.(recordId);
				closeHandler();
			}
		})
	});
}
//#endregion
export { CreateRecordModal };

//# sourceMappingURL=index.js.map